<ion-card class="card-info-over">
  <ion-card-header>
    <ion-card-title class="card-info-over-title">{{ message.title }}</ion-card-title>
  </ion-card-header>
  <ion-card-content [innerHTML]="message.description"></ion-card-content>
</ion-card>
